import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

class EnlargeImage extends Component {
  
  render() {
    console.log("in here props imageUrl" , this.props.imageUrl)
    return (
        <div className="enlarged-image-overlay" onClick={this.props.onClose}>
          <span className="close-icon-in-overlay" onClick={this.props.onClose}>
        
          <FontAwesomeIcon icon={faTimes} />

    </span>
        <div className="enlarged-image-container">
     
          <img src={this.props.imageUrl} alt="Enlarged" className="enlarged-image" />
    
        
        </div>
      </div>
    );
  }
}

export default EnlargeImage;